import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading
Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  // {
  //   path: "/login",
  //   component: () => import("@/views/login/index"),
  //   hidden: true
  // },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true
  },
  {
    path: "/pay",
    name: "school",
    meta: { title: "支付", icon: "dashboard", affix: true },
    component: () => import("@/views/pay/index"),
  },
  {
    path: "",
    component: Layout,
    name: "",
    // hidden: true,
    children: [
      // {
      //   path: "/pay",
      //   name: "school",
      //   meta: { title: "支付", icon: "dashboard", affix: true },
      //   component: () => import("@/views/pay/index"),
      // },
      {
        path: "/",
        name: "school",
        meta: { title: "学校", icon: "dashboard", affix: true },
        component: () => import("@/views/school/index"),
      },
      {
        path: "/school/details",
        name: "details",
        // meta: { title: "帖子列表", icon: "dashboard", affix: true },
        component:() => import("@/views/school/details"),
      },
      {
        path: "/forum",
        name: "forum",
        // meta: { title: "论坛", icon: "dashboard", affix: true },
        component: () => import("@/views/forum/index"),
        children:[
          {
            path: "/forum/list",
            name: "list",
            // meta: { title: "帖子列表", icon: "dashboard", affix: true },
            component:() => import("@/views/forum/list"),
          },
          {
            path: "/forum/sendForum",
            name: "sendForum",
            // meta: { title: "发布帖子", icon: "dashboard", affix: true },
            component:() => import("@/views/forum/sendForum"),
          },
          {
            path: "/forum/forumDetails",
            name: "forumDetails",
            // meta: { title: "帖子详情", icon: "dashboard", affix: true },
            component:() => import("@/views/forum/forumDetails"),
          },
          {
            path: "/forum/userDetails",
            name: "userDetails",
            // meta: { title: "用户主页", icon: "dashboard", affix: true },
            component:() => import("@/views/forum/userDetails"),
          },
          {
            path: "/forum/notifyLog",
            name: "notifyLog",
            // meta: { title: "消息", icon: "dashboard", affix: true },
            component:() => import("@/views/forum/notifyLog"),
          },
        ]
      },
      {
        path: "/match",
        name: "match",
        // meta: { title: "比赛", icon: "dashboard", affix: true },
        component: () => import("@/views/match/index"),
        children:[
          {
            path: "/match/match",
            name: "match",
            // meta: { title: "比赛列表", icon: "dashboard", affix: true },
            component:() => import("@/views/match/match"),
          },
          {
            path: "/match/details",
            name: "details",
            // meta: { title: "比赛详情", icon: "dashboard", affix: true },
            component:() => import("@/views/match/details"),
          },
        ]
      },
      {
        path: "/mine",
        name: "mine",
        // meta: { title: "我的", icon: "dashboard", affix: true },
        component: () => import("@/views/mine/index"),
        children:[
          // 我的钱包
          {
            path: "/mine/my_wallet/index",
            name: "my_wallet",
            // meta: { title: "我的钱包", icon: "dashboard", affix: true },
            component:() => import("@/views/mine/my_wallet/index"),
            children:[
              {
                path: "/mine/my_wallet/consumption",
                name: "consumption",
                // meta: { title: "消费记录", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_wallet/consumption"),
              },
              {
                path: "/mine/my_wallet/order",
                name: "order",
                // meta: { title: "订单记录", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_wallet/order"),
              },
            ]
          },
          // 我的社区
          {
            path: "/mine/my_community/index",
            name: "my_community",
            // meta: { title: "我的社区", icon: "dashboard", affix: true },
            component:() => import("@/views/mine/my_community/index"),
            children:[
              {
                path: "/mine/my_community/my_attention",
                name: "my_attention",
                // meta: { title: "我的关注", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_community/my_attention"),
              },
              {
                path: "/mine/my_community/follow_my",
                name: "follow_my",
                // meta: { title: "关注我的", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_community/follow_my"),
              },
              {
                path: "/mine/my_community/my_release",
                name: "my_release",
                // meta: { title: "我的发布", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_community/my_release"),
              },
              {
                path: "/mine/my_community/my_collection",
                name: "my_collection",
                // meta: { title: "我的收藏", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_community/my_collection"),
              },
              {
                path: "/mine/my_community/my_comments",
                name: "my_comments",
                // meta: { title: "我的评论", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_community/my_comments"),
              }
            ]
          },
          // 我的赛事
          {
            path: "/mine/my_match/index",
            name: "my_match",
            // meta: { title: "我的赛事", icon: "dashboard", affix: true },
            component:() => import("@/views/mine/my_match/index"),
            children:[
              {
                path: "/mine/my_match/my_registration",
                name: "my_registration",
                // meta: { title: "我的报名", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_match/my_registration"),
              },
              {
                path: "/mine/my_match/my_team",
                name: "my_team",
                // meta: { title: "我的战队", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_match/my_team"),
              }
            ]
          },
          // 我的学习
          {
            path: "/mine/my_study/index",
            name: "my_study",
            // meta: { title: "我的学习", icon: "dashboard", affix: true },
            component:() => import("@/views/mine/my_study/index"),
            children:[
              {
                path: "/mine/my_study/my_homework",
                name: "my_homework",
                // meta: { title: "我的作业", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/my_homework"),
              },
              {
                path: "/mine/my_study/do_homework",
                name: "do_homework",
                // meta: { title: "我的作业", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/do_homework"),
              },
              {
                path: "/mine/my_study/my_classroom",
                name: "my_classroom",
                // meta: { title: "我的电竞第二课堂", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/my_classroom"),
              },
              {
                path: "/mine/my_study/my_timetable",
                name: "my_timetable",
                // meta: { title: "我的课程表", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/my_timetable"),
              },
              {
                path: "/mine/my_study/my_achievement",
                name: "my_achievement",
                // meta: { title: "我的成绩", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/my_achievement"),
              },
              {
                path: "/mine/my_study/question_bank",
                name: "my_achievement",
                // meta: { title: "电竞技能课程题库", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/index"),
              },
              {
                path: "/mine/my_study/question_bank/subject",
                name: "subject",
                // meta: { title: "电竞技能课程题目", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/subject"),
              },
              {
                path: "/mine/my_study/question_bank/record",
                name: "subject",
                // meta: { title: "答题记录", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/record"),
              },
              {
                path: "/mine/my_study/question_bank/type",
                name: "subject",
                // meta: { title: "答题类型", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/type"),
              },
              {
                path: "/mine/my_study/question_bank/record_details",
                name: "record_details",
                // meta: { title: "答题记录详情", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/record_details"),
              },
              {
                path: "/mine/my_study/question_bank/examination",
                name: "examination",
                // meta: { title: "考试列表", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/examination"),
              },
              {
                path: "/mine/my_study/question_bank/start_exam",
                name: "start_exam",
                // meta: { title: "开始考试", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/start_exam"),
              },
              {
                path: "/mine/my_study/question_bank/exam_details",
                name: "exam_details",
                // meta: { title: "考试详情", icon: "dashboard", affix: true },
                component:() => import("@/views/mine/my_study/question_bank/exam_details"),
              }
            ]
          },
        ]
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index")
      }
    ]
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  }
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "teaching_task",
  //   meta: { title: "教学任务", permissions: ["admin", "role"], icon: "content" },
  //   children: [
  //     {
  //       path: "/teaching_task/my_course",
  //       name: "my_course",
  //       component: () => import("@/views/teaching_task/my_course"),
  //       meta: { title: "我的课程", permissions: ["admin"] }
  //     },
  //     {
  //       path: "/admin/list",
  //       name: "instructional_design",
  //       component: () => import("@/views/admin/index"),
  //       meta: { title: "教学设计", permissions: ["admin"] }
  //     },
  //     {
  //       path: "/admin/list",
  //       name: "Courseware_materials",
  //       component: () => import("@/views/admin/index"),
  //       meta: { title: "课件资料", permissions: ["admin"] }
  //     },
  //     {
  //       path: "/admin/list",
  //       name: "student_examination",
  //       component: () => import("@/views/admin/index"),
  //       meta: { title: "学生考试", permissions: ["admin"] }
  //     },
  //     {
  //       path: "/teaching_task/student_achievement",
  //       name: "student_achievement",
  //       component: () => import("@/views/teaching_task/student_achievement"),
  //       meta: { title: "学生成绩", permissions: ["admin"] }
  //     },
  //   ]
  // },
  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "curriculum_management",
  //   meta: { title: "课程表管理", permissions: ["admin", "role"], icon: "system" },
  //   children: [
  //     {
  //       path: "/curriculum_management/course_schedule",
  //       name: "course_schedule",
  //       component: () => import("@/views/curriculum_management/course_schedule"),
  //       meta: { title: "课程表排课", permissions: ["admin"] }
  //     },
  //     {
  //       path: "/curriculum_management/record",
  //       name: "record",
  //       component: () => import("@/views/curriculum_management/record"),
  //       meta: { title: "我的排课记录", permissions: ["admin"] },
  //     },
  //     {
  //       hidden:true,
  //       path: "/curriculum_management/job_management/job_list",
  //       name: "course_schedule",
  //       component: () => import("@/views/curriculum_management/job_management/job_list"),
  //       meta: { title: "作业管理", permissions: ["admin"] }
  //     },
  //     {
  //       hidden:true,
  //       path: "/curriculum_management/job_management/set_job",
  //       name: "set_job",
  //       component: () => import("@/views/curriculum_management/job_management/set_job"),
  //       meta: { title: "设置作业", permissions: ["admin"] }
  //     },
  //     {
  //       hidden:true,
  //       path: "/curriculum_management/job_management/correct_job",
  //       name: "correct_job",
  //       component: () => import("@/views/curriculum_management/job_management/correct_job"),
  //       meta: { title: "批改作业", permissions: ["admin"] }
  //     },
  //     {
  //       hidden:true,
  //       path: "/curriculum_management/view_students/view_students",
  //       name: "correct_job",
  //       component: () => import("@/views/curriculum_management/view_students/view_students"),
  //       meta: { title: "查看学生", permissions: ["admin"] }
  //     },
  //   ]
  // },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "Others",
  //   meta: { title: "课堂题库管理", icon: "others" },
  //   children: [
  //     {
  //       path: "/map",
  //       name: "Map",
  //       component: () => import("@/views/others/map"),
  //       meta: { title: "题库管理" }
  //     }
  //   ]
  // },
  { path: "*", redirect: "/error/404", hidden: true }
];
